// Timer
function countdownTimer() {
  let countDownDate = 0;
  // Set the date we're counting down to
  let getNewDate = document
    .querySelector("[date-time-picker]")
    .getAttribute("date-time-picker");

  if (getNewDate) {
    getNewDate = getNewDate + " GMT";
    countDownDate = new Date(getNewDate).getTime();
  }
  // var ukFormat = countDownDate.toLocaleString("en-GB", {
  //   dateStyle: "full",
  //   timeStyle: "long",
  //   timeZone: "Europe/London",
  // });
  // console.log(countDownDate);
  // console.log(typeof ukFormat);
  // let finalukFormat = ukFormat.replaceAll("," , "");
  // console.log(finalukFormat);
  // Update the count down every 1 second
  var x = setInterval(function () {
    // Get todays date and time
    var now = new Date().getTime();

    // Find the distance between now and the count down date
    var distance = countDownDate - now;
    // var distance = finalukFormat - now;

    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    var hrs = days * 24 + hours;

    // Display the result in the element with id="demo"
    // document.getElementById("demo").innerHTML = hrs + "h "
    // + minutes + "m " + seconds + "s ";
    // Hours
    if (hrs < 10) {
      let newHrs = "0" + hrs;
      document.querySelector("#countdown-text-hours").innerHTML = newHrs;
    } else {
      document.querySelector("#countdown-text-hours").innerHTML = hrs;
    }

    // Minutes
    // document.querySelector("#countdown-text-minutes").innerHTML = minutes;
    if (Number(minutes) < 10) {
      let newMinutes = "0" + minutes;
      document.querySelector("#countdown-text-minutes").innerHTML = newMinutes;
    } else {
      document.querySelector("#countdown-text-minutes").innerHTML = minutes;
    }

    // Seconds
    if (Number(seconds) < 10) {
      let newSeconds = "0" + seconds;
      document.querySelector("#countdown-text-seconds").innerHTML = newSeconds;
    } else {
      document.querySelector("#countdown-text-seconds").innerHTML = seconds;
    }

    // If the count down is finished, write some text
    if (distance < 0) {
      clearInterval(x);
      // document.getElementById("demo").innerHTML = "EXPIRED";
      document.querySelector("#countdown-text-seconds").innerHTML = "00";
      document.querySelector("#countdown-text-minutes").innerHTML = "00";
      document.querySelector("#countdown-text-hours").innerHTML = "00";
    }
  }, 1000);
}

// Swiper JS
function swiperjs() {
  var swiper = new Swiper(".mySwiper", {
    spaceBetween: 30,
    loop: true,
    centeredSlides: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  var swiperTwo = new Swiper(".mySwiper-two", {
    spaceBetween: 30,
    observer: true,
    observeParents: true,
    loop: true,
    centeredSlides: true,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination-two",
      clickable: true,
    },
  });
}

// alert('sup');
document.addEventListener("DOMContentLoaded", () => {
  document.querySelector(".clickMeButton").addEventListener("click", () => {
    alert("this is an alert !");
  });
});

document.addEventListener("DOMContentLoaded", () => {
  countdownTimer();
  swiperjs();
});
